export default "__VITE_ASSET__wsT3cgxy__"